module.exports = "images/teamed_image_08.png";